import {
  ApplicationInsights
} from '@microsoft/applicationinsights-web'

export let appInsights

export function initAppInsights () {
  var metatag = document.querySelectorAll('meta[property="instrumentationkey"]')
  if (metatag.length > 0) {
    appInsights = new ApplicationInsights({ config: {
      instrumentationKey: metatag[0].getAttribute('content'),
      enableAutoRouteTracking: true,
      disableCookiesUsage: true
    } })
    appInsights.loadAppInsights()
    appInsights.trackPageView()
  }
}
